var _style, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutOfPaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.7 56.7",
    style: {
      enableBackground: "new 0 0 56.7 56.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#656262;}\n\t.st1{opacity:0;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,56H12.7c-0.7,0-1.4-0.7-1.4-1.4V42.8H2.2c-0.7,0-1.4-0.5-1.4-1.2c0-0.2,0-0.5,0-0.7v-3.8 c0-3.8,0-7.4,0-11.2c0-6,4.1-10.8,10-11.7c0.7,0,1.4-0.2,2.2-0.2c10.3,0,20.6,0,31.1,0c6,0,10.5,3.8,11.7,9.6 c0.2,1,0.2,2.2,0.2,3.1c0,3.3,0,6.9,0,10.3v4.1v0.5c0,0.7-0.7,1.4-1.4,1.4h-9.1v11.7C45.2,55.5,44.7,56,44,56z M13.9,53.3h28.7 V41.6c0-0.7,0.7-1.4,1.4-1.4h9.1v-3.3c0-3.3,0-6.9,0-10.3c0-1,0-1.7-0.2-2.6c-1-4.3-4.5-7.2-9.1-7.2c-10.3,0-20.6,0-31.1,0 c-0.5,0-1,0-1.7,0.2c-4.5,0.7-7.6,4.5-7.6,9.1c0,3.8,0,7.4,0,11.2v2.9h9.1c0.7,0,1.4,0.7,1.4,1.4V53.3z M38.7,50.7H17.9 c-0.7,0-1.4-0.7-1.4-1.4V36.4c0-0.7,0.7-1.4,1.4-1.4h20.8c0.7,0,1.4,0.7,1.4,1.4v12.9C39.9,50.2,39.5,50.7,38.7,50.7z M19.1,48.1 h18.2V37.8H19.1V48.1z M46.6,27.3C46.6,27.3,46.4,27.3,46.6,27.3c-2.4,0-4.1-1.7-4.1-4.1c0-2.4,1.7-3.8,4.1-3.8 c2.4,0,4.1,1.7,4.1,4.1c0,1.2-0.5,2.2-1.2,2.9C48.5,26.8,47.6,27.3,46.6,27.3z M46.6,22c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2 c0.5,0,0.7,0,1-0.2c0.2-0.2,0.2-0.5,0.2-1C47.8,22.5,47.3,22,46.6,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,14.1H12.7c-0.7,0-1.4-0.7-1.4-1.4V2.2c0-0.7,0.7-1.4,1.4-1.4H44c0.7,0,1.4,0.7,1.4,1.4v10.5 C45.2,13.6,44.7,14.1,44,14.1z M13.9,11.5h28.7V3.8H13.9V11.5z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st1",
    width: 56.7,
    height: 56.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfPaper);
export default __webpack_public_path__ + "static/media/out-of-paper.f1b5a717c15945598f50061aacd35f8a.svg";
export { ForwardRef as ReactComponent };